import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import Brand from './Brand';
import { navItems } from '../data/siteData';

function MobileNavigation({ activeSection, onNavigate }) {
  return (
    <>
      <header className="mobile-header">
        <Brand />
        <span className="live-pill"><i /> Booking made simple</span>
      </header>
      <nav className="mobile-dock" aria-label="Mobile navigation">
        {navItems.map((item) => (
          <button
            key={item.target}
            type="button"
            className={activeSection === item.target ? 'active' : ''}
            onClick={() => onNavigate(item.target)}
            aria-label={item.label}
          >
            {activeSection === item.target && <motion.span layoutId="mobile-tab" />}
            <SafeIcon icon={item.icon} />
            <small>{item.label}</small>
          </button>
        ))}
      </nav>
    </>
  );
}

export default MobileNavigation;